import { Button, DatePicker, Col } from "antd";
import styled from "styled-components";

const { RangePicker } = DatePicker;
// 容器组件
export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const DateCom = styled(RangePicker)`
  height: 30px;
  margin: 0 10px;
`;

export const TableButton = styled(Button)`
  border: none;
  background-color: transparent;
  box-shadow: none;
  font-size: 14px;
  font-weight: 500;
  color: #3775ed;
`;

export const ExportButton = styled(Button)`
  height: 32px;
  background: #3775ed;
  border-radius: 20px;
  background: linear-gradient(45deg, #886dff 0%, #af5fff 100%);
  color: white;
`;

export const ExportText = styled.span`
  margin-left: 5px;
`;

export const ColCom = styled(Col)`
  padding: 0 5px;
`;

export const Text = styled(Col)`
  color: #886dff;
  text-align: center;
  cursor: pointer;
`;
